import { defineModule } from '@/lib/module-routes'

import { styleGuideRoutes } from './routes'

export const styleGuideModule = defineModule({
  routes: styleGuideRoutes,
})
